<template>
  <div class="famousSaying">
    <div class="famousSayingTitle">
      <v-icon>mdi-alert-circle-outline</v-icon>
      {{sentence}}
    </div>
  </div>
</template>
<script>
export default {
  name: "FamousSaying",
  data(){
    return {
      sentence: undefined
    }
  },
  methods: {
    getFamousSaying(){
      // this.$axios.get('/challenges/sentences').then(response => {
      //   this.sentence = response.data;
      // })
      const famousSentence = ['명언입니다.', '명언입니다.2', '명언입니다.3', '명언입니다.4', '명언입니다.5'];
      function randomMath(min,max){
        return Math.floor(Math.random()*(max-min+1)+min);
      }
      this.sentence = famousSentence[randomMath(0,4)];
    }
  },
  mounted(){
    this.getFamousSaying();
  }
};
</script>
<style lang="scss" scoped>
.famousSaying{
  padding: 0 20px;
  
  .famousSayingTitle{
    padding: 8px 0;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: flex-start;
    color: #999;
    font-size: 14px;

    i{
      margin-right: 8px;
      color: inherit;
      font-size: 22px;
      vertical-align: middle;
    }
  }
}
</style>